// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@tps/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import xScreen from "@tps/XDL/Utilities/xScreen";
import { css } from "styled-components";

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodSelect = {
    cssOverrides: {
        formField: css`
            width: 430px;
            max-width: 100%;
            ${xScreen("lte", "md")} {
                width: 360px;
            }
            ${xScreen("lte", 767)} {
                width: 100%;
            }
        `,
    },
};
checkoutReviewAndSubmitPaymentDetailsStyles.poNumberWrapper = {
    css: css`
        display: flex;
        width: 100%;
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.promocodeWrapper = {
    css: css`
        width: 100%;
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.poNumberGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        align-items: flex-end;
        padding-left: 22px;
        ${xScreen("lte", "md")} {
            width: 360px;
            align-items: flex-start;
            padding-left: 0;
        }
    `,
};
checkoutReviewAndSubmitPaymentDetailsStyles.poPromoCodeWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        width: 430px;

        max-width: 100%;
        ${xScreen("lte", "md")} {
            padding-top: 20px;
            width: 360px;
        }
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.paymentMethodAndPONumberContainer = {
    gap: 0,
    css: css`
        margin-bottom: 0;
    `,
};
